export enum QuoteType {
  Basic = "Basic",
  Detailed = "Detailed",
}

export enum BasicUsageIntensity {
  Low = "Low",
  Medium = "Medium",
  High = "High",
}

export enum CookingFuel {
  Gas = "Gas",
  Electricity = "Electricity",
}

export enum HeatingFuel {
  Gas = "Gas",
  Electricity = "Electricity",
  Other = "Other",
}

export interface IUsageEstimation {
  electricity: number
  gas: number
  electricityDay: number
  electricityNight: number
}

export interface IUsageProfile {
  gasUsage: number
  electricityUsage: number
  electricityTwoRateUsage: number
}

export interface IDetailedUsageProfileAttrs {
  cooking: keyof typeof CookingFuel
  heating: keyof typeof HeatingFuel
  bedrooms: number
}

export interface IElectricVehicleType {
  name: string
  range: number
  batteryCapacity: number
}

export interface IElectricVehicleUsage {
  vehicle: IElectricVehicleType | null
  milesPerYear: number
}

export interface ISolarPanel {
  name: string
  annualOutput: number
}

export interface ISolarPanelConfiguration {
  panel: ISolarPanel | null
  panelCount: number
}

export interface IUsageAdjustment {
  dayNightUsageRatio?: number
  electricVehicles?: IElectricVehicleUsage[]
  solarPanelConfiguration?: ISolarPanelConfiguration
}

export type UsageOfgemMap = Record<
  keyof typeof BasicUsageIntensity,
  IUsageProfile
>

export interface IUsageProfileDetailed
  extends IUsageProfile, IDetailedUsageProfileAttrs {}
